// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1200px) {
  .footer_footer__xvcPw {
    background-color: #ECEFF1;
  }
}
.footer_footer__xvcPw .NoFindBtn {
  margin-top: 20px;
  margin-bottom: 20px;
}
@media (min-width: 640px) {
  .footer_footer__xvcPw .NoFindBtn {
    margin-top: 16px;
    margin-bottom: 16px;
  }
}
.footer_footer__wp__zTakh {
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (min-width: 640px) {
  .footer_footer__wp__zTakh {
    padding-top: 80px;
  }
}
@media (min-width: 1200px) {
  .footer_footer__wp__zTakh {
    flex-direction: row;
    justify-content: space-between;
    max-width: var(--container);
    padding: var(--grid-spacing);
    margin: 0 auto;
  }
}
.footer_footer__xvcPw p {
  font-size: 13px;
  font-style: normal;
  line-height: 14px;
  text-align: center;
  color: #667799;
}
@media (min-width: 640px) {
  .footer_footer__xvcPw p {
    font-size: 16px;
  }
}
@media (min-width: 1200px) {
  .footer_footer__xvcPw p {
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
    text-align: left;
    max-width: 350px;
  }
}
.footer_footer__info__m9We\\+ {
  text-align: center;
}
@media (min-width: 1200px) {
  .footer_footer__info__m9We\\+ {
    text-align: left;
  }
}
.footer_footer__logoWrap__s0REy {
  max-width: 144px;
  display: flex;
  margin: 0 auto 10px;
}
@media (min-width: 1200px) {
  .footer_footer__logoWrap__s0REy {
    margin: 0 0 10px;
  }
}
.footer_footer__logoWrap__s0REy span {
  max-width: 100%;
  display: flex;
}
.footer_footer__logoWrap__s0REy svg, .footer_footer__logoWrap__s0REy img {
  width: auto;
  max-height: 48px;
  max-width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.module.scss"],"names":[],"mappings":"AACE;EADF;IAEI,yBAAA;EACF;AACF;AAEI;EACE,gBAAA;EACA,mBAAA;AAAN;AAEM;EAJF;IAKI,gBAAA;IACA,mBAAA;EACN;AACF;AAGE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EANF;IAOI,iBAAA;EAAJ;AACF;AAEI;EAVF;IAWI,mBAAA;IACA,8BAAA;IACA,2BAAA;IACA,4BAAA;IACA,cAAA;EACJ;AACF;AAEE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AAEI;EAPF;IAQI,eAAA;EACJ;AACF;AACI;EAXF;IAYI,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,gBAAA;EAEJ;AACF;AACE;EACE,kBAAA;AACJ;AACI;EAHF;IAII,gBAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EALF;IAMI,gBAAA;EAEJ;AACF;AAAI;EACE,eAAA;EACA,aAAA;AAEN;AACI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AACN","sourcesContent":[".footer {\n  @media (min-width: 1200px) {\n    background-color: #ECEFF1;\n  }\n\n  :global {\n    .NoFindBtn {\n      margin-top: 20px;\n      margin-bottom: 20px;\n\n      @media (min-width: 640px) {\n        margin-top: 16px;\n        margin-bottom: 16px;\n      }\n    }\n  }\n\n  &__wp {\n    padding-top: 70px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    @media (min-width: 640px) {\n      padding-top: 80px;\n    }\n\n    @media (min-width: 1200px) {\n      flex-direction: row;\n      justify-content: space-between;\n      max-width: var(--container);\n      padding: var(--grid-spacing);\n      margin: 0 auto;\n    }\n  }\n\n  p {\n    font-size: 13px;\n    font-style: normal;\n    line-height: 14px;\n    text-align: center;\n    color: #667799;\n\n    @media (min-width: 640px) {\n      font-size: 16px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-sm);\n      line-height: var(--lh-sm);\n      text-align: left;\n      max-width: 350px;\n    }\n  }\n\n  &__info {\n    text-align: center;\n\n    @media (min-width: 1200px) {\n      text-align: left;\n    }\n  }\n\n  &__logoWrap {\n    max-width: 144px;\n    display: flex;\n    margin: 0 auto 10px;\n\n    @media (min-width: 1200px) {\n      margin: 0 0 10px;\n    }\n\n    span {\n      max-width: 100%;\n      display: flex;\n    }\n\n    svg, img {\n      width: auto;\n      max-height: 48px;\n      max-width: 150px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__xvcPw`,
	"footer__wp": `footer_footer__wp__zTakh`,
	"footer__info": `footer_footer__info__m9We+`,
	"footer__logoWrap": `footer_footer__logoWrap__s0REy`
};
export default ___CSS_LOADER_EXPORT___;
